<template>
    <div class="options-panel">
        <div class="smr-panel__header">
            <nav class="options-panel__nav" :class="{'is-nav-interacted': interacted}">
                <ItemSlider 
                    :key="itemSliderIndex"
                    slider-class="options-panel__nav__slider" 
                    :slider-options="sliderOptions" 
                    :hideUIUntilInteraction="sliderShowMoreLabel" 
                    @interacted="sliderInteractedHandler"
                    :tooltips="tooltipArrowsContent"
                    ref="nav-slider"
                >
                    <SwiperSlide 
                        :ref="isTabActive(tab.id) ? 'active-nav-link' : 'nav-link'"
                        class="options-panel__nav__link" 
                        v-for="(tab, tabIndex) in tabs" 
                        :key="tab.id" 
                        :class="{'is-active-tab' : isTabActive(tab.id), 'is-more-label-tab' : checkIfIsMoreLabelTab(tabIndex)}" 
                        @click.native="selectTab(tab.id)"
                    >
                        <div class="options-panel__nav__link__inner bold-label">{{tab.label}}</div>
                        <div class="options-panel__nav__link__inner options-panel__nav__link__inner--more bold-label" v-if="checkIfIsMoreLabelTab(tabIndex)" @click.stop="moreLabelClickHandler">+{{ tabs.length - moreLabelIndex}} Weitere</div>
                    </SwiperSlide>
                </ItemSlider>
            </nav>
        </div>
        <div class="smr-panel__body">
            <div class="options-panel__body__item" v-for="tab in tabs" :key="tab.id" :class="{'is-active-tab': isTabActive(tab.id)}">
                <component :is="getBodyComponentName(tab.component)" v-if="isTabActive(tab.id)" :initial-data="initialData[tab.id]" :options-id="tab.id" @change="bodyComponentChangeHandler($event, tab.id)"/>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ItemSlider from '@/components/ItemSlider.vue'
import Loader from '@/components/Loader.vue'
// import eventBus from '@/utils/event-bus';
import { trackEvent } from '@/utils/tracking'
import SmrButton from '@/components/SmrButton.vue'
import SmrTooltip from '@/components/SmrTooltip.vue'
import Icon from '@/components/Icon.vue'
import IconCheck from '@/components/icons/IconCheck.vue'
import IconClose from '@/components/icons/IconClose.vue'

import POISettingsTraffic from '@/components/POISettingsTabs/POISettingsTraffic.vue';
import POISettingsGasStations from '@/components/POISettingsTabs/POISettingsGasStations.vue';
import POISettingsCarParks from '@/components/POISettingsTabs/POISettingsCarParks.vue';
import POISettingsOeamtcLocations from '@/components/POISettingsTabs/POISettingsOeamtcLocations.vue';
import POISettingsPartners from '@/components/POISettingsTabs/POISettingsPartners.vue';
import POISettingsFavourites from '@/components/POISettingsTabs/POISettingsFavourites.vue';
import POISettingsNearbyStations from '@/components/POISettingsTabs/POISettingsNearbyStations.vue';
import POISettingsPassRoads from '@/components/POISettingsTabs/POISettingsPassRoads.vue';
import POISettingsRoadHouses from '@/components/POISettingsTabs/POISettingsRoadHouses.vue';
import POISettingsCamping from '@/components/POISettingsTabs/POISettingsCamping.vue';
import POISettingsSights from '@/components/POISettingsTabs/POISettingsSights.vue';
import POISettingsTollRoads from '@/components/POISettingsTabs/POISettingsTollRoads.vue';
import POISettingsTravelRadar from '@/components/POISettingsTabs/POISettingsTravelRadar.vue';
import POISettingsChargingStations from '@/components/POISettingsTabs/POISettingsChargingStations.vue'

import RouteSettingsGeneral from '@/components/RouteSettingsTabs/RouteSettingsGeneral.vue';
import RouteSettingsCar from '@/components/RouteSettingsTabs/RouteSettingsCar.vue';
import RouteSettingsPublic from '@/components/RouteSettingsTabs/RouteSettingsPublic.vue';
import RouteSettingsCamper from '@/components/RouteSettingsTabs/RouteSettingsCamper.vue';
import RouteSettingsTrailer from '@/components/RouteSettingsTabs/RouteSettingsTrailer.vue';
import RouteSettingsBike from '@/components/RouteSettingsTabs/RouteSettingsBike.vue';
import RouteSettingsMotorcycle from '@/components/RouteSettingsTabs/RouteSettingsMotorcycle.vue';
import RouteSettingsSharing from '@/components/RouteSettingsTabs/RouteSettingsSharing.vue';

export default {
    components: {
        Loader,
        SmrButton,
        SmrTooltip,
        Icon,
        IconCheck,
        IconClose,
        ItemSlider,
        POISettingsTraffic,
        POISettingsGasStations,
        POISettingsCarParks,
        POISettingsOeamtcLocations,
        POISettingsPartners,
        POISettingsFavourites,
        POISettingsNearbyStations,
        POISettingsPassRoads,
        POISettingsRoadHouses,
        POISettingsCamping,
        POISettingsSights,
        POISettingsTollRoads,
        POISettingsTravelRadar,
        POISettingsChargingStations,
        RouteSettingsGeneral,
        RouteSettingsCar,
        RouteSettingsMotorcycle,
        RouteSettingsPublic,
        RouteSettingsCamper,
        RouteSettingsTrailer,
        RouteSettingsBike,
        RouteSettingsSharing,
    },
    props: {
        tabs: {
            default: () => [],
            type: Array
        },
        saving: {
            default: false,
            type: Boolean
        },
        initialTab: {
            default: false,
            type: [String, Boolean]
        },
        initialData: {
            default: () => {},
            type: Object
        },
        moreLabelIndex: {
            type: Number,
            default: 6
        }
    },
    data() {
        return {
            activeTab: '',
            interacted: false,
            itemSliderIndex: 0,
            sliderOptions: {
                slidesPerView: 'auto',
                watchOverflow: true,
                touchStartPreventDefault: false,
                freeMode: true,
                freeModeMomentumRatio: 0.5,
                slidesOffsetBefore: 16,
                slidesOffsetAfter: 16,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                slideToClickedSlide: true,
                centeredSlides: true,
                centeredSlidesBounds: true,
                threshold: 10,
            },
            tooltipArrowsContent: {
                left: {
                    content: 'Weitere Kategorien',
                    position: 'bottom'
                },
                right: {
                    content: 'Weitere Kategorien',
                    position: 'bottom'
                }
            }
        }
    },
    computed: {
        ...mapGetters(['mobile']),
        sliderShowMoreLabel() {
            return !this.mobile;
        },
    },
    watch: {
        initialTab(newVal, oldVal) {
            if(newVal && newVal !== oldVal) {
                this.activeTab = newVal
            }
        }
    },
    mounted() {
        this.initPanelView()
    },
    methods: {
        saveClickHandler() {
            trackEvent({ category: 'Route Planner', action: 'Options', label: 'Save' })
            this.saveOptions();
        },
        sliderInteractedHandler(){
            this.interacted = true;
        },
        moreLabelClickHandler() {
            this.$refs['nav-slider'].slideDir('right', true);
        },
        bodyComponentChangeHandler(data, id) {
            this.$emit('settings-change', {data, id});
        },
        initOptions() {
            this.interacted = false;
            this.itemSliderIndex++;
            this.dialogVisible = true;
            this.activeTab = this.initialTab ? this.initialTab : this.tabs[0].id;
            setTimeout(() => {
                this.scrollToActiveTab();
            }, 10);
        },
        saveOptions() {
            this.$emit('save');
        },
        isTabActive(id) {
            return id === this.activeTab;
        },
        selectTab(id) {
            this.activeTab = id;
        },
        getBodyComponentName(component) {
            return component ? component : false;
        },
        checkIfIsMoreLabelTab(tabIndex) {
            return !this.mobile && tabIndex === this.moreLabelIndex && !this.interacted;
        },
        resetActiveTab() {
            setTimeout(() => {
                this.selectTab(''); // wait until the dialog closes and reset the active tab so that the tab content gets refreshed if the popup is displayed again
            }, 500);
        },
        scrollToActiveTab() {
            const activeLink = this.$refs['active-nav-link'][0];
            if(!activeLink) return false;
            const activeLinkLeft = activeLink.$el.offsetLeft;
            const activeLinkWidth = activeLink.$el.clientWidth;
            const navSlider = this.$refs['nav-slider'];
            const navSliderWidth = navSlider.$el.clientWidth;
            if( 
                (this.mobile && (activeLinkLeft + activeLinkWidth > navSliderWidth)) ||
                (!this.mobile && (!activeLink.$el.classList.contains('swiper-slide-visible') || activeLink.$el.classList.contains('is-more-label-tab')))
            ) {
                const position = activeLinkLeft - (navSliderWidth * 0.5) + (activeLinkWidth * 0.5);
                navSlider.slideToPosition(-position);
            }
        },
        initPanelView() {
            this.initOptions()
            if(this.$refs['nav-slider']) {
                this.$refs['nav-slider'].update()
            }
        }
    }
}
</script>

<style lang="scss">
.options-panel {
    height: 100%;
    display: flex;
    flex-direction: column;

    &__nav {
        position: relative;
        overflow: hidden;
        width: 100%;
        @include mq(tablet) {
            padding-right: 20px;
        }
        &__link {
            transition: color 0.2s;
            padding: 0 10px;
            overflow: hidden;
            color: $color-black-05;
            cursor: pointer;
            width: auto;
            position: relative;
            user-select: none;
            &.is-active-tab,
            .no-touch &:hover {
                color: $color-black;
            }
            &:first-child {
                padding-left: 0;
            }
            &:last-child {
                padding-right: 0;
            }
            @include mq(tablet) {
                &.is-more-label-tab {
                    overflow: visible;
                    & ~ .swiper-slide {
                        visibility: hidden;
                    }
                }
            }

            &__inner {
                padding: 17px 0;
                position: relative;
                .is-more-label-tab & {
                    visibility: hidden;
                    min-width: 76px;
                    &--more {
                        visibility: visible;
                        position: absolute;
                        top: 0;
                        white-space: nowrap;
                    }
                }
                &::after {
                    content: '';
                    transition: transform 0.2s;
                    transform: translateY(100%);
                    position: absolute;
                    display: block;
                    background-color: $color-yellow;
                    height: 2px;
                    left: 0;
                    bottom: 0;
                    width: 100%;
                }
                .is-active-tab & {
                    &::after {
                        transform: none;
                    }
                }
            }
        }
        &__more-items {
            position: absolute;
            right: 0;
            top: 0;
        }
    }
}
</style>